var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 2.91699H5.83268C3.33268 2.91699 1.66602 4.16699 1.66602 7.08366V12.917C1.66602 15.8337 3.33268 17.0837 5.83268 17.0837H14.166C16.666 17.0837 18.3327 15.8337 18.3327 12.917V7.08366C18.3327 4.16699 16.666 2.91699 14.166 2.91699ZM14.5577 7.99199L11.9493 10.0753C11.3993 10.517 10.6993 10.7337 9.99935 10.7337C9.29935 10.7337 8.59102 10.517 8.04935 10.0753L5.44102 7.99199C5.17435 7.77533 5.13268 7.37533 5.34102 7.10866C5.55768 6.84199 5.94935 6.79199 6.21602 7.00866L8.82435 9.09199C9.45768 9.60033 10.5327 9.60033 11.166 9.09199L13.7744 7.00866C14.041 6.79199 14.441 6.83366 14.6493 7.10866C14.866 7.37533 14.8243 7.77533 14.5577 7.99199Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.369c68c7bea628ce8e5cf6d99771ad8b.svg";
export { ForwardRef as ReactComponent };